import { compose } from 'redux';
import { connect } from 'react-redux';
import insurancePlanDecorator from 'insurance/insurancePlans/decorator';
import ConfirmInsurance from './ConfirmInsurance';
import { createSprintPurchase } from 'insurance/actions';

export default compose(
  insurancePlanDecorator,
  connect(
    null,
    { createPurchase: createSprintPurchase }
  )
)(ConfirmInsurance);
